<template>
    <div class="grid">
        <div class="col-12">
			<div class="card">
				<h5>Edit Employee</h5>
                <TabView v-model:activeIndex="active">
                    <TabPanel :header="$t('personal-info')">
                        <Personal ref="personal" :submitted="submitted"></Personal>
                        <div class="p-fluid">
                            <Button @click="savePersonal" id="button1" label="Save" />
                        </div>
                    </TabPanel>
                    <TabPanel :header="$t('professional-info')">
                        <Professional ref="professional" :submitted="submitted"></Professional>
                        <div class="p-fluid">
                            <Button @click="saveProfessional" id="button1" label="Save" />
                        </div>
                    </TabPanel>
                    <TabPanel :header="$t('salary')">
                        <SalaryVue ref="salary" :submitted="submitted"></SalaryVue>
                        <div class="p-fluid">
                            <Button @click="saveSalary" id="button1" label="Save" />
                        </div>
                    </TabPanel>
                    <TabPanel :header="$t('families')">
                        <Relative></Relative>
                    </TabPanel>
                    <TabPanel :header="$t('formal-education')">
                        <Education></Education>
                    </TabPanel>
                    <TabPanel :header="$t('certification')">
                        <Certification></Certification>
                    </TabPanel>
                    <TabPanel :header="$t('work-history')">
                        <WorkHistory></WorkHistory>
                    </TabPanel>
                </TabView>
			</div>
		</div>
    </div>
</template>
<script>
import axios from 'axios';
import Button from 'primevue/button';
import AppLayout from '../../Layouts/AppLayout';
import Personal from './Components/Personal';
import Professional from './Components/Professional';
import Relative from './Components/Relative';
import Education from './Components/Education';
import Certification from './Components/Certification';
import WorkHistory from './Components/WorkHistory';
import SalaryVue from './Components/Salary.vue';
import Dropdown from 'primevue/dropdown';
import InputText from 'primevue/inputtext';
import TabView from 'primevue/tabview';
import TabPanel from 'primevue/tabpanel';
import Textarea from 'primevue/textarea';

export default {
    layout: AppLayout,
    components: {Button, InputText, Dropdown, Textarea, TabView, TabPanel, Personal, Professional, Relative, Education, Certification, WorkHistory, SalaryVue},
    data(){
        return{
            active: 0,
            submitted: false,
        }
    },
    methods:{
        savePersonal(){
            this.submitted = true;
            let personal = this.$refs.personal.form;
            let validated = true;

            if(Object.keys(personal).length === 0){
                validated = false;
            }

            for (const record in personal) {
                if (!personal[record] && record != 'position_class' && record != 'team' && record != 'foto' ){
                    validated = false;
                }
            }

            if(validated){
                this.submitted = false;

                let payload = {...personal};
                axios.put(`${this.$page.props.appUrl}api/employees/${this.$page.props.employee.id}`,payload)
                .then((data) => {
                    this.$toast.add({
                        severity: "success",
                        summary: "Successful",
                        detail: "Employee Updated",
                        life: 3000,
                    });
                })
                .catch((error) => {
                    this.$toast.add({
                        severity: "error",
                        summary: "Error When Updating Employee",
                        detail: error,
                        life: 3000,
                    });
                })
            }
        },
        saveProfessional(){
            this.submitted = true;
            let professional = this.$refs.professional.form;
            let validated = true;

            if(Object.keys(professional).length === 0){
                validated = false;
            }

            if(validated){
                this.submitted = false;

                let payload = {...professional};
                axios.put(`${this.$page.props.appUrl}api/employee-salary/${this.$page.props.employee.salary.id}`,payload)
                .then((data) => {
                    this.$toast.add({
                        severity: "success",
                        summary: "Successful",
                        detail: "Employee Salary Updated",
                        life: 3000,
                    });
                })
                .catch((error) => {
                    this.$toast.add({
                        severity: "error",
                        summary: "Error When Updating Employee Salary",
                        detail: error,
                        life: 3000,
                    });
                })
            }
        },
        saveSalary(){
            this.submitted = true;
            let salary = this.$refs.salary.form;
            let validated = true;

            if(Object.keys(salary).length === 0){
                validated = false;
            }

            if(validated){
                this.submitted = false;

                let payload = {...salary};
                axios.put(`${this.$page.props.appUrl}api/employee-salary/${this.$page.props.employee.salary.id}`,payload)
                .then((data) => {
                    this.$toast.add({
                        severity: "success",
                        summary: "Successful",
                        detail: "Employee Salary Updated",
                        life: 3000,
                    });
                })
                .catch((error) => {
                    this.$toast.add({
                        severity: "error",
                        summary: "Error When Updating Employee Salary",
                        detail: error,
                        life: 3000,
                    });
                })
            }
        },
    }
}
</script>
